import React from 'react';
import { shape, string } from 'prop-types';
import { useStyle } from '../../classify';
import Shimmer from '../Shimmer';
import defaultClasses from './filterSidebar.module.css';

var FilterSidebar = function FilterSidebar(props) {
  var classes = useStyle(defaultClasses, props.classes);
  return React.createElement("aside", {
    className: classes.root,
    "aria-live": "polite",
    "aria-busy": "true"
  }, React.createElement(Shimmer, {
    width: "95%",
    height: "70vh",
    style: {
      marginBottom: 25
    }
  }));
};

FilterSidebar.propTypes = {
  classes: shape({
    root: string
  })
};
export default FilterSidebar;